<template>
    <div id="enquiriesScreen">
        <div id="enquiries">
            <div class="enquiriesWrap">
                <div class="logoTitle">
                    <img class="logo"
                         src="@/assets/images/footballAssociation.png"
                         alt="">
                    <img class="title"
                         src="@/assets/images/title_picture.png"
                         alt="">
                </div>
                <div class="enquiriesBox" >
                    <div class="title">
                        <div style="font-size: 18px;">创建{{level_type}}帐户</div>
                        <span class="sub-title" v-if="the_quality === 'eleven'">（仅限于参加过中国足协D/C/B/A/职业级和2008年之前的岗位培训初/中/高级教练员进行创建帐户）</span>
                        <span class="sub-title" v-else>（仅限于参加过中国足协五人制足球初级/L1/L2/L3/职业级培训的教练员创建帐户）</span>
                    </div>
                    <div class="register">
                        <div class="register_info left">
                            <template v-if="step===1">
                                <el-form :model="form" label-width="110px" ref="formInfo" :rules="formRules">
                                    <el-form-item  label="证件类型" class="form_item" style="position: relative" prop="id_type">
                                        <el-select v-model="form.id_type"
                                                   placeholder="请选择证件类型"
                                                   style="width: 100%;" @change="changeType()">
                                            <el-option
                                              v-for="(item, index) in id_types"
                                              :key="index"
                                              :label="item.key"
                                              :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <div class="example" v-if="form.id_type === 'idTypeCode_wgjzz'">
                                            <p class="intro">示例</p>
                                            <div class="showExample" >
                                                <p class="nameExample">外国人永久居留身份证</p>
                                                <div class="img">
                                                    <img :src="wgjzz" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="example" v-if="form.id_type === 'idTypeCode_HMT'">
                                            <p class="intro">示例</p>
                                            <div class="showExample" >
                                                <p class="nameExample">港澳台居民居住证</p>
                                                <div class="img">
                                                    <img :src="HMT" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="example" v-if="form.id_type === 'idTypeCode_HMT'">
                                            <p class="intro">示例</p>
                                            <div class="showExample" >
                                                <p class="nameExample">港澳台居民居住证</p>
                                                <div class="img">
                                                    <img :src="HMT" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="example" v-if="form.id_type === 'HM'">
                                            <p class="intro">示例</p>
                                            <div class="showExampledouble" >
                                                <p class="nameExample">港澳居民来往内地通行证</p>
                                                <div class="img">
                                                    <div class=""  class="section">
                                                        <p class="l_title">港澳居民来往内地通行证示例（1999版）</p>
                                                        <img :src="HM1999" alt="">
                                                    </div>
                                                    <div style="margin-left: 10px" class="section">
                                                        <p class="l_title">港澳居民来往内地通行证示例（2012版）</p>
                                                        <img :src="HM2012" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="example" v-if="form.id_type === 'TAI'">
                                            <p class="intro">示例</p>
                                            <div class="showExampledouble" >
                                                <p class="nameExample">台湾居民来往大陆通行证</p>
                                                <div class="img">
                                                    <div class=""  class="section">
                                                        <p class="l_title">台湾居民来往大陆通行证（2002版）</p>
                                                        <img :src="TAI2002" alt="">
                                                    </div>
                                                    <div style="margin-left: 10px" class="section">
                                                        <p class="l_title">台湾居民来往大陆通行证（2015版）</p>
                                                        <img :src="TAI2015" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-form-item>
                                    <el-form-item  label="颁发国家/地区" class="form_item" prop="country" v-if="this.form.id_type==='passport'">
                                        <el-select v-model="form.country"
                                                   placeholder="请选择国家/地区"
                                                   style="width: 100%;"
                                                   filterable>
                                            <el-option
                                              v-for="item in allCountry"
                                              :key="item.country_code"
                                              :label="item.country_zh"
                                              :value="item.country_code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item  label="颁发国家/地区" class="form_item" prop="country" v-if="this.form.id_type !=='passport' && this.form.id_type !==''">
                                        <el-select v-model="form.country"
                                                   style="width: 100%;">
                                            <el-option
                                              key="CN"
                                              label="中国"
                                              value="CN">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item  label="身份有效证件号" class="form_item" prop="id_number">
                                        <el-input :placeholder="id_numberMsg" v-model.trim="form.id_number"></el-input>
                                    </el-form-item>
                                    <el-form-item  label="姓名" class="form_item" prop="name">
                                        <el-input placeholder="请输入姓名" v-model.trim="form.name"></el-input>
                                    </el-form-item>
                                    <!-- 此表单内容不参与信息交互 -->
                                    <el-form-item label="当前等级" class="form_item" prop="level">
                                        <el-select placeholder="请选择最高等级" v-model="form.level" style="width: 100%">
                                            <el-option v-for="(item, index) in levelList" :key="index" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-row>
                                        <el-col :span="15">
                                            <el-form-item label-width="110px" label="验证码" class="form_item" prop="verification_code">
                                                <el-input placeholder="请输入验证码" v-model.trim="form.verification_code"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8" :offset="1">
                                            <div class="code-wrap" >
                                                <img :src="verificationBase64"  v-show="!showLoading"
                                                     @load="showLoading=false" >
                                                <div class="loadImgIng"  v-show="showLoading">
                                                    <i class="el-icon-loading loading-code" ></i>
                                                </div>
                                                <div class="refresh-code" @click="getPhotoCode" >看不清，换一张</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <div class="enter_next_step next" >
                                    <el-button type="primary" @click="enter_next_step()" :loading="loading" :disabled="loading">下一步</el-button>
                                </div>
                            </template>
                            <template v-if="step===2">
                                <el-form :model="enrrolForm" ref="enrollForm" :rules="formRules">
                                    <el-form-item label-width="110px" label="身份有效证件号" class="enroll_form_item" prop="id_number" >
                                        <el-input placeholder="请输入身份有效证件号" v-model="enrrolForm.id_number" disabled></el-input>
                                    </el-form-item>
                                    <el-form-item label-width="110px" label="手机号" class="enroll_form_item" prop="mobile_phone" >
                                        <el-input placeholder="请输入手机号" v-model="enrrolForm.mobile_phone" ></el-input>
                                    </el-form-item>
                                    <el-row style="position: relative">
                                        <el-col :span="14">
                                            <el-form-item label-width="110px" label="验证码" class="form_item" prop="code" style="margin-bottom: 22px">
                                                <el-input placeholder="请输入验证码" v-model="enrrolForm.code"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="9" :offset="1">
                                            <div class="getcode" v-if="codeFlag" @click="sendcode">获取验证码</div>
                                            <div class="waittime" v-else>{{sec}}秒后重新发送</div>
                                        </el-col>
                                        <el-popover
                                                placement="right"
                                                title="解决办法"
                                                width="400"
                                                trigger="hover"
                                                popper-class="method_no_code"
                                        >
                                            <p>1: 通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；</p>
                                            <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>
                                            <p>3: 请确认手机号码是否正确，手机是否欠费；</p>
                                            <p>4: 关机后重新启动手机，重新加载手机和基站的通信链路；</p>
                                            <p>5: 联系电话客服；</p>
                                            <div class="get_none_code" slot="reference" >收不到验证码？</div>
                                        </el-popover>
                                    </el-row>
                                    <el-form-item label-width="110px" label="密码" class="enroll_form_item enroll_password" prop="password" >
                                        <el-input placeholder="请输入密码" type="password" v-model="enrrolForm.password" ></el-input>
                                    </el-form-item>
                                    <el-form-item label-width="110px" label="确认密码" class="enroll_form_item enroll_password" prop="affirm_password" >
                                        <el-input placeholder="请再次输入密码" type="password" v-model="enrrolForm.affirm_password" ></el-input>
                                    </el-form-item>
                                </el-form>
                                <div class="enter_next_step erroll" >
<!--                                    <el-button type="primary" @click="pre_step()" style="margin-left: 80px">上一步</el-button>-->
                                    <el-button type="primary" @click="enrroll()" :loading="enrrolLoading" :disabled="enrrolLoading">创建完成</el-button>
                                </div>
                            </template>
                            <template v-if="step===3">
                                <div class="boxCenter">
                                    <div class="success">
                                        <div class="tips">
                                            <i class="el-icon-success"></i>
                                            <p>创建成功 !</p>
                                        </div>
                                        <div class="intro">
                                            <p>
                                                请登录中国足协教练员培训管理系统，即可查询教练员资质。
                                            </p>
                                        </div>
                                        <div class="tips-btn" @click="goLogin">
                                            <span v-text="second"></span>
                                            <span>s后请输入密码登录</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="split_line"></div>
                        <div class="register_info right">
                            <p  class="special_title">注：</p>
                            <p class="special_first" v-if="the_quality === 'eleven'">1.根据符合《亚足联教练员公约》的新版本等级证书和执教执照格式要求，部分教练员登录或者创建帐户后需按照系统要求完善新证书和执照颁发所需照片、姓名拼音等信息，待中国足协确认信息后可更新教练员资质状态。</p>
                            <p class="special_first" v-else>1.教练员登录或者创建帐户后需按照系统要求完善照片、简历等信息，待中国足协确认信息后可更新教练员资质状态。</p>
                            <p >2.部分教练员登录或者创建帐户后可能查询不到完整或部分本人教练员资质，可按照系统要求完善缺失的资质培训信息，待中国足协比对核查后可更新教练员资质状态。</p>
                            <p >3.如遇到姓名与证号不一致的情况，请将您的姓名、身份证照片、参加过的等级培训的级别、时间、讲师等信息发送至邮箱 songmh@yioks.com</p>
                            <div class="back_home">
                                <el-button type="primary" @click="goback">返回</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
        <yioks-iKnow :showTips="backTips" tips="您已经创建过帐户，请返回中国足协教练员培训管理系统直接登录。" @hideTips="hideBackTips"></yioks-iKnow>
    </div>
</template>

<script>

    import "vue-awesome/icons/regular/file-alt";
    import ops from '@/assets/js/vuescrollOption';
    import wgjzz from '@/assets/images/tips/wgjzz.png'
    import HMT from '@/assets/images/tips/HMT.png'
    import HM1999 from '@/assets/images/tips/HM1999.png'
    import HM2012 from '@/assets/images/tips/HM2012.png'
    import TAI2002 from '@/assets/images/tips/TAI2002.png'
    import TAI2015 from '@/assets/images/tips/TAI2015.png'
    import {getPhotoCode, selectAchievementData, uuidGetData} from "@/api/common/achievement";
    import commonFun from "@/assets/js/yioks";
    import {personnel_send_verification, enroll_personnel_register} from "@/api/ab_signup/api";
    import {coach_register_check,coach_register_ajax} from "@/api/ab_signup/api";
    const { uuid } = commonFun;
    import { hex_hmac_sha256 } from "@/assets/js/sha";
    import {id_types } from "@/assets/js/select";
    import {countryArr} from "@/assets/js/country";
    export default {
        name: "high_end_register",
        data() {
            return {
                wgjzz,
                HMT,
                HM1999,
                HM2012,
                TAI2002,
                TAI2015,
                ops: ops(),
                sec:60,
                hideTips:false,
                nameFlag:'',
                nameMsg:'',
                enrrolLoading:false,
                backTips:false,
                second:5,
                codeFlag:true,
                loading:false,
                showLoading: true,
                numberMsg:'',
                numberFlag:false,
                allCountry:countryArr.slice(1),
                id_types:id_types,
                id_numberMsg:'请输入身份有效证件号',
                form:{
                    level: '',
                    name:'',
                    id_number:'',
                    country:'CN',
                    id_type:'id_number',
                    verification_code:''
                },
                enrrolForm:{
                    name:'',
                    id_number:'',
                    mobile_phone:'',
                    id_type:'',
                    country:'',
                    code:'',
                    puuid:'',
                    password:'',
                    affirm_password:'',
                },
                puuid:'',
                code_msg:'',
                code_flag:false,
                verificationBase64:'',
                nonce_str: '',
                phoneFlag:'',
                phoneMsg:'',
                step:1,
                formRules:{
                    level: [
                        { validator: (rule, val, cb) =>{
                            if(val) {
                                cb();
                            } else {
                                cb(new Error('请选择最高等级'))
                            }
                            },
                            trigger: 'blur'
                        }
                    ],
                    name: [{
                        validator: (rule, val, callback) => {
                            if (val) {
                                if (!this.nameFlag) {
                                    callback();
                                } else {
                                    this.nameFlag = false;
                                    callback(new Error(this.nameMsg));
                                }
                            }
                            else {
                                callback(new Error('请输入姓名'));
                            }
                        },
                        trigger: 'blur'
                    }],
                    id_type: [{
                        validator: (rule, val, callback) => {
                            if (val) {
                                callback();
                            }
                            else {
                                callback(new Error('请选择证件类型'));
                            }
                        },
                        trigger: 'change'
                    }],
                    country: [{
                        validator: (rule, val, callback) => {
                            if (val) {
                                callback();
                            }
                            else {
                                callback(new Error('请选择颁发国家/地区'));
                            }
                        },
                        trigger: 'change'
                    }],
                    id_number: [{
                        validator: (rule, val, callback) => {
                            if (val) {
                                if(this.form.id_type === 'id_number'){
                                    if (this.$yioks.idCard_number(val)){
                                        callback()
                                    } else{
                                        callback(new Error('请输入有效的证件号'))
                                    }
                                }else if(this.form.id_type === 'passport'){
                                    if (this.$yioks.checkPassport(val)){
                                        callback()
                                    } else{
                                        callback(new Error('请输入有效的护照号码'))
                                    }
                                }
                                else if(this.form.id_type === 'idTypeCode_wgjzz'){
                                    if (this.$yioks.checkWork(val)){
                                        callback()
                                    } else{
                                        callback(new Error('请输入有效的外国人居留证号码'))
                                    }
                                }
                                else if(this.form.id_type === 'HM'){
                                    if (this.$yioks.checkHkongMacao(val)){
                                        callback()
                                    } else{
                                        callback(new Error('请输入9位有效的港澳居民来往内地通行证号码'))
                                    }
                                }
                                else if(this.form.id_type === 'TAI'){
                                    if (this.$yioks.checkTaiwOld(val)){
                                        callback()
                                    } else{
                                        callback(new Error('请输入8位有效的台湾居民来往大陆通行证号码'))
                                    }
                                }
                                else if(this.form.id_type === 'idTypeCode_HMT'){
                                    if ( /^8[1-3]\d{16}/.test(val) && this.$yioks.idCard_number(val)){
                                        callback()
                                    } else{
                                        callback(new Error('请输入18位有效的港澳台居民居住证号码'))
                                    }
                                }
                            } else {
                                callback(new Error('请输入身份有效证件号'));
                            }
                        },
                        trigger: 'blur'
                    }],
                    verification_code: [{
                        validator: (rule, val, callback) => {
                            if (val) {
                                if (!this.code_flag) {
                                    callback();
                                } else {
                                    this.code_flag = false;
                                    callback(new Error(this.code_msg));
                                }
                            } else {
                                callback(new Error('请输入验证码'));
                            }
                        },
                        trigger: 'blur'
                    }],
                    mobile_phone:[{
                        validator: (rule, val, callback) => {
                            if (!this.$yioks.phone(val)) {
                                callback(new Error("请输入有效的手机号"));
                            } else {
                                if (!this.phoneFlag) {
                                    callback();
                                } else {
                                    this.phoneFlag = false;
                                    callback(new Error(this.phoneMsg));
                                }
                            }
                        },
                        trigger: "blur"
                    }],
                    password: [
                        {
                            validator: (rule, val, callback) => {
                                if (!val){
                                    callback(new Error("请输入密码"))
                                }
                                else if (!this.$yioks.pwd(val)) {
                                    callback(new Error("8—16位字母（区分大小写）和数字组合"));
                                } else {
                                    callback();
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    affirm_password:[
                        {
                            validator: (rule, val, callback) => {
                                if (!val){
                                    callback(new Error("请再次输入密码"))
                                }
                                else if (!this.$yioks.pwd(val)) {
                                    callback(new Error("8—16位字母（区分大小写）和数字组合"));
                                } else if(val !== this.enrrolForm.password){
                                    callback(new Error('两次密码不一致'));
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    code: [{
                        validator: (rule, val, callback) => {
                            if (!val){
                                callback(new Error('请输入验证码'))
                            }
                            else if (!this.$yioks.code(val)) {
                                callback(new Error("请输入有效的验证码"));
                            } else {
                                if (!this.numberFlag) {
                                    callback();
                                } else {
                                    this.numberFlag = false;
                                    callback(new Error(this.numberMsg));
                                }
                            }
                        },
                        trigger: "blur"
                    }]
                }
            };
        },
        computed: {
            the_quality() {
                const { the_quality } = this.$route.query;
                return the_quality;
            },

            level_type() {
                const { the_quality } = this.$route.query;
                if(the_quality === 'futsal') return '五人制'
                else return '十一人制'
            },

            levelList() {
                if(this.the_quality === 'eleven') {
                    return  [
                        { label: '中国足协D级教练员（十一人制）', value: '中国足协D级教练员（十一人制）'},
                        { label: '中国足协C级教练员（十一人制）', value: '中国足协C级教练员（十一人制）'},
                        { label: '中国足协B级教练员（十一人制）', value: '中国足协B级教练员（十一人制）'},
                        { label: '中国足协A级教练员（十一人制）', value: '中国足协A级教练员（十一人制）'},
                        { label: '中国足协职业级教练员（十一人制）', value: '中国足协职业级教练员（十一人制）'}
                    ]
                } else if(this.the_quality === 'futsal') {
                    return [
                         { label: '足球初级教练员（五人制）', value: '足球初级教练员（五人制）'},
                         { label: '足球L1级教练员（五人制）', value: '足球L1级教练员（五人制）'},
                         { label: '足球L2级教练员（五人制）', value: '足球L2级教练员（五人制）'},
                         { label: '足球L3级教练员（五人制）', value: '足球L3级教练员（五人制）'},
                         { label: '足球职业级教练员（五人制）', value: '足球职业级教练员（五人制）'},
                    ]
                } else {
                    return []
                }
            }
        },
        components: {
            "v-icon": () => import("vue-awesome/components/Icon"),
            "app-footer": () => import("@/components/LayOut/Common/Footer"),
            "yioks-tips": () => import("@/components/Tips/Dialog"),
            "yioks-iKnow": () => import('@/components/Tips/iKnow'),
        },
        created() {
            this.nonce_str = uuid();
            this.getPhotoCode();
        },
        methods:{
            getPhotoCode() {
                this.showLoading = true;
                getPhotoCode({nonce_str: this.nonce_str, timestamp: new Date().getTime()})
                    .then((res) => {
                        if (Number(res.data.status) === 0) {
                            this.verificationBase64 = res.data.result.verificationBase64;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                        this.showLoading=false
                    })
                    .catch((err) => {
                        this.verificationBase64='error.jpg';
                        this.showLoading=false
                    });
            },
            enter_next_step(){
                this.loading=true;
                this.$refs['formInfo'].validate(valid=>{
                   if (valid){
                       const { level, ...rest } = this.form;
                       coach_register_check({
                           // ...this.form, // 新增的level不参与信息交互操作
                           ...rest,
                           the_quality: this.the_quality,
                           nonce_str:this.nonce_str
                       }).then(res=>{
                           if(Number(res.data.status)===0 ){
                               const{puuid,is_newUser,qualification_record_status}=res.data.result;
                               if (Number(is_newUser)===0){
                                   this.backTips=true;
                               }
                               else if(Number(is_newUser)===1 || Number(is_newUser)===2){
                                    if (!qualification_record_status) {
                                        /* 创建*/
                                        this.$router.push({
                                            path:'/qualification',
                                            query:{
                                                puuid:puuid,
                                                the_quality: this.the_quality,
                                            }
                                        })
                                    }else if(qualification_record_status==='perfect'){
                                        /* 编辑*/
                                        this.$router.push({
                                            path:'/editQualification',
                                            query:{
                                                puuid:puuid,
                                                the_quality: this.the_quality,
                                            }
                                        })
                                    }else if (qualification_record_status==='audit'){
                                        /* 查看*/
                                        this.$router.push({
                                            path:'/lookQualification',
                                            query:{
                                                puuid:puuid,
                                                the_quality: this.the_quality,
                                            }
                                        })
                                    }else if (qualification_record_status==='OK') {
                                        if(Number(is_newUser)===1) {
                                            this.step+=1;
                                            this.enrrolForm.puuid=puuid;
                                            this.enrrolForm.name=this.form.name;
                                            this.enrrolForm.id_number=this.form.id_number;
                                            this.enrrolForm.id_type=this.form.id_type;
                                            this.enrrolForm.country=this.form.country;
                                        } else if(Number(is_newUser)===2 ){
                                            this.step = 3;
                                            this.enrrolForm.id_number=this.form.id_number;
                                            this.newcountdown();    // 开始倒计时
                                        }
                                    }
                                    else{
                                        console.log('shayebushi')
                                        this.loading=false;
                                        return false;
                                    }
                               }
                               this.loading=false;
                           }else{
                             if(Number(res.data.status===511)){
                               this.$message.error(res.data.msg+"，参见右侧注释3。");
                             }else{
                               this.$message.error(res.data.msg);
                             }
                               this.getPhotoCode()
                           }
                           if (Number(res.data.status)===510 || Number(res.data.status)===457){
                               this.code_msg=res.data.msg;
                               this.code_flag=true;
                               this.$refs['formInfo'].validateField("verification_code");
                               this.getPhotoCode()
                           }
                           if(Number(res.data.status===511)){
                               this.nameFlag=true;
                               this.nameMsg=res.data.msg+"，参见右侧注释3。";
                               this.$refs['formInfo'].validateField("name");
                               this.getPhotoCode()
                           }
                           this.loading=false;
                       }).catch(err=>{
                          console.log(err);
                           this.loading=false;
                       });
                       this.loading=false;
                   } else{
                       this.getPhotoCode();
                      this.$message.error('请填写完整信息');
                      this.loading=false;
                   }
              })
            },
            pre_step(){
                this.step-=1;
                this.$refs['enrollForm'].resetFields();
                this.getPhotoCode();
            },
            hideBackTips(bool,flag){
                this.backTips=false;
                this.$router.push({
                    path:'/login',
                    query:{
                        tmpUserName:this.form.id_number
                    }
                });
            },
            sendcode() {
                if (!this.$yioks.phone(this.enrrolForm.mobile_phone)){
                    this.$refs["enrollForm"].validateField("mobile_phone");
                    return
                }
                personnel_send_verification({
                    mobile_phone: this.enrrolForm.mobile_phone
                })
                    .then(res => {
                        if (Number(res.data.status) === 0) {
                            this.$message.success("验证码发送成功");
                            this.codeFlag = false;
                            /* 倒计时 */
                            this.countdown();
                        } else if (
                            Number(res.data.status) === 421 ||
                            Number(res.data.status) === 420 ||
                            Number(res.data.status) === 419
                        ) {
                            this.numberFlag = true;
                            this.numberMsg = res.data.msg;
                            this.$refs["enrollForm"].validateField("code");
                            this.$message.error(res.data.msg);
                        } else if (Number(res.data.status) === 405) {
                            this.phoneFlag = true;
                            this.phoneMsg = res.data.msg;
                            this.$refs["enrollForm"].validateField("mobile_phone");
                            this.$message.error(res.data.msg);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            countdown() {
                const timer = setInterval(() => {
                    this.$data.sec = this.$data.sec - 1;
                    if (this.$data.sec === 0) {
                        this.$data.sec = 60;
                        this.$data.codeFlag = true;
                        clearInterval(timer);
                    }
                }, 1000);
            },
            newcountdown() {
                // console.log(this.data.sec)
                const timer = setInterval(() => {
                    this.$data.second = this.$data.second - 1;
                    if (this.$data.second === 0) {
                        clearInterval(timer);
                        this.goLogin();
                    }
                }, 1000);
            },
            enrroll(){
                this.enrrolLoading=true;
                this.$refs['enrollForm'].validate(valid=>{
                    if (valid){
                        coach_register_ajax({
                            ...this.enrrolForm,
                            regist_salt:this.nonce_str,
                            the_quality:this.the_quality,
                            password:hex_hmac_sha256(this.nonce_str,this.enrrolForm.password).toUpperCase(),
                            affirm_password:hex_hmac_sha256(this.nonce_str,this.enrrolForm.affirm_password).toUpperCase()
                        }).then(res=>{
                            if (Number(res.data.status)===0){
                                this.step+=1;
                                this.newcountdown()
                            }
                            else if(Number(res.data.status)===109){
                                this.numberFlag = true;
                                this.numberMsg = res.data.msg;
                                this.$refs["enrollForm"].validateField("code");
                            }
                            else{
                                this.$message.error(res.data.msg)
                            }
                            this.enrrolLoading=false;
                        }).catch(err=>{
                            console.log(err);
                            this.enrrolLoading=false;
                        })
                    } else {
                        this.enrrolLoading=false;
                        this.$message.error('请填写完整信息');
                    }
                })

            },
            goback(){
                if (this.step===1){
                    this.$router.go(-1)
                }else if(this.step===2){
                    this.step-=1;
                } else if(this.step===3){
                    this.$router.push({
                        path:'/login',
                        query:{
                            tmpUserName:this.enrrolForm.id_number
                        }
                    });
                }

            },
            goLogin(){
                this.$router.push({
                    path:'/login',
                    query:{
                        tmpUserName:this.enrrolForm.id_number
                    }
                });
            },
            changeType(){
                switch (this.form.id_type) {
                    case "id_number": // 身份证
                        this.form.country="CN";
                        this.id_numberMsg="请输入身份证号";
                        break;
                    case "idTypeCode_wgjzz": // 外国人永久居留身份证
                        this.form.country="CN";
                        this.id_numberMsg="例如：CAN000000000000";
                        break;
                    case "idTypeCode_HMT": // 港澳台居民居住证
                        this.form.country="CN";
                        this.id_numberMsg="请输入港澳台居民居住证号";
                        break;
                    case "HM": // 港澳居民来往内地通行证
                        this.form.country="CN";
                        this.id_numberMsg="例如：H00000000";
                        break;
                    case "TAI": // 台湾居民来往大陆通行证
                        this.form.country="CN";
                        this.id_numberMsg="例如：00000000";
                        break;
                    case "passport": // 护照（非中国大陆人员）
                        this.form.country="";
                        this.id_numberMsg="例如：E00000000";

                        break;
                }
            }
        }
    };
</script>

<style lang="stylus">
    @import '~@/assets/css/variable';
    #enquiriesScreen {
        .el-form-item__label {
            color: $color_white;
        }
        .el-form-item {
            margin-bottom: 40px;
        }
    }
</style>

<style lang="stylus" scoped>
    @import '~@/assets/css/variable';
    #enquiriesScreen {
        width: 100%;
        height: 100%;
        #enquiries {
            height: calc(100% - 60px);
            display: flex;
            justify-content: center;
            user-select: none;
            .enquiriesWrap {
                width: 1024px;
                padding: 95px 0 0;
                display: flex;
                flex-direction: column;
                .logoTitle {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 0 0 50px 0;
                    .logo {
                        width: 120px;
                        height: 120px;
                        margin: 0 15px 0 0;
                    }
                }
                .enquiriesBox {
                    align-self: center;
                    width: 900px;
                    height: 550px;
                    padding: 0 50px 0px 50px;
                    background-color: $block_bg_color_base;
                    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
                    position: relative;
                    color: $color_white;
                    .title{
                        display flex
                        /*justify-content space-between*/
                        justify-content flex-start
                        margin: 30px 0;
                        border-bottom: 2px solid;
                        padding-bottom: 10px;
                        h2{
                            font-size: 25px;
                        }
                    }
                    .register{
                        display flex
                        justify-content space-between
                        .register_info{
                            flex-basis 45%
                            .form_item{
                                margin-bottom 15px
                                .example{
                                    position absolute
                                    right -37px
                                    font-size 16px
                                    top 10px
                                    .intro{
                                        text-decoration underline
                                        cursor pointer
                                        color #4cd964
                                    }
                                    .showExample{
                                        display none
                                        position absolute
                                        width 400px
                                        left -200px
                                        z-index 999
                                        background-color white
                                        .nameExample{
                                            /*text-align center*/
                                            color black
                                            text-align center
                                        }
                                        .img{
                                            padding 0 20px 10px
                                        }
                                        &::before{
                                            content ''
                                            position absolute
                                            top -8px
                                            left 200px
                                            border-bottom 8px solid white
                                            border-right 8px solid transparent
                                            border-left 8px solid transparent
                                        }
                                    }
                                    .showExampledouble{
                                        display none
                                        position absolute
                                        width 600px
                                        left -300px
                                        z-index 999
                                        background-color white
                                        .nameExample{
                                            /*text-align center*/
                                            color black
                                            text-align center
                                        }
                                        .img{
                                            display flex
                                            padding 0 20px 10px
                                            .section{
                                                .l_title{
                                                    font-size 14px
                                                    color black
                                                    text-align center
                                                }
                                            }
                                        }
                                        &::before{
                                            content ''
                                            position absolute
                                            top -8px
                                            left 300px
                                            border-bottom 8px solid white
                                            border-right 8px solid transparent
                                            border-left 8px solid transparent
                                        }
                                    }
                                    &:hover{
                                        .showExample{
                                            display: block
                                        }
                                        .showExampledouble{
                                            display: block
                                        }
                                    }

                                }
                            }
                            .enroll_form_item{
                                margin-bottom 22px
                            }
                            .getcode {
                                width: 125px;
                                display: inline-block;
                                line-height: 1.7;
                                white-space: nowrap;
                                border-radius 4px
                                cursor: pointer;
                                text-align: center;
                                outline: none;
                                padding: 8px 16px;
                                background-color: #4cd964;
                            }
                            .waittime {
                                width: 125px;
                                border-radius 4px
                                /*margin-left: 20px;*/
                                display: inline-block;
                                line-height: 1.7;
                                white-space: nowrap;
                                cursor: pointer;
                                text-align: center;
                                outline: none;
                                padding: 8px 16px;
                                background-color: #909399;
                            }
                            .get_none_code{
                                position absolute
                                bottom 0
                                cursor pointer
                                right 0
                                color $color_white
                            }
                            .code-wrap{
                                img{
                                    width 144px
                                    height 40px
                                }
                                .refresh-code{
                                    font-size 16px
                                    color $color_suc
                                    cursor pointer
                                }
                                .loadImgIng{
                                    background-color #fff
                                    width 114px
                                    height 40px
                                    text-align center
                                    color black
                                    font-size 30px
                                }
                            }
                            .enter_next_step{
                                margin-top 27px
                                text-align right
                            }
                            .next{
                                margin-top 18px
                            }
                            .erroll{
                                display flex
                                justify-content flex-end
                            }

                            .boxCenter {
                                padding: 20px 40px;
                                .mobile_phone, .code, .pwd, .affirm_pwd {
                                    margin: 0 0 35px;
                                    display: flex;
                                    border: 2px solid;
                                    position: relative;

                                    .tips {
                                        position: absolute;
                                        left: 0;
                                        bottom: -30px;
                                        color: $color_err;
                                        font-size: $font_size_small;
                                    }

                                    .icon {
                                        width: 36px;
                                        height: 36px;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        color: #ceced2;
                                        background-color: $color_white;
                                        border-right: 1px solid #ceced2;
                                    }
                                }

                                .boxTip {
                                    font-size: 16px;
                                    color: #dddddd;
                                }
                                .success {
                                    text-align: center;
                                    .tips {
                                        .el-icon-success {
                                            color: $color_suc;
                                            font-size: 60px;
                                        }
                                        p {
                                            margin: 30px 0 0;
                                            color: $color_white;
                                            font-size: 25px;
                                        }
                                    }
                                    .intro{
                                        margin-top 15px
                                        font-size 15px
                                    }
                                    .tips-btn {
                                        margin: 107px 0 0;
                                        padding: 10px 0;
                                        color: $color_white;
                                        font-size: 14px;
                                        background-color: $color_suc;
                                        cursor: pointer;
                                    }
                                }
                            }

                        }
                        .left{
                            flex-basis 45%
                        }
                        .right{
                            p{
                                font-size 15px;
                                margin-top 20px
                            }
                            .back_home{
                                margin-top 43px
                                text-align right
                            }
                            .special_title{
                                font-size 16px
                                margin-top 0
                            }
                            .special_first{
                                margin-top 6px
                            }
                        }
                        .split_line{
                            height 440px
                            width 1px
                            border 1px solid white
                            margin -20px 60px 0 60px
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="stylus" >
    @import '~@/assets/css/variable';
    .enquiriesLeft{
        .el-form-item__label{
            font-size 16px
            font-weight bold
        }
    }
    .register_info{
        .el-form-item__error{
            white-space nowrap
        }
    }
    .sub-title
        display flex
        align-items flex-end
        /*margin-left 5px*/
        font-size 15px
        color #ff0000
</style>
<style lang="stylus">
    .method_no_code{
        .el-popover__title{
            border-bottom 1px solid black
            padding-bottom 2px
        }
    }
</style>
